import React, {useContext, useState} from "react";
import Icon from "@mui/material/Icon";
import {LanguageContext} from "../../context/LanguageContext";
import {Box, Menu, MenuItem} from "@mui/material";
import {languageOptions} from "../../languages";
import Flags from "country-flag-icons/react/3x2";
import IconButton from "@mui/material/IconButton";
import PropTypes from "prop-types";

const LanguageButton = ({ renderMiniMenu }) => {
  const languageContext = useContext(LanguageContext);
  const [selectedLanguage, setSelectedLanguage] = useState(languageContext.language);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => setAnchorEl(event.currentTarget);

  const handleClose = () => setAnchorEl(null);

  const handleLanguageChange = (languageId) => {
    const actualLanguage = languageOptions.find(item => item.id === languageId);
    handleClose();
    setTimeout(() => {
      languageContext.setLanguage(actualLanguage);
      setSelectedLanguage(actualLanguage);
    }, 100);
  };

  return (
    <Box>
      <IconButton sx={{ height: 50, width: 50 }} onClick={handleClick}>
        <Icon sx={{ color: "secondary.main" }}>{"language"}</Icon>
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={!!anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: renderMiniMenu ? "top" : "left"
        }}
        onClose={handleClose}
      >
        {languageOptions.map(languageOption => (
          <MenuItem
            sx={{ backgroundColor: selectedLanguage.id === languageOption.id ? "primary.bgColor" : "" }}
            key={`languageOption_${languageOption.id}`}
            onClick={() => handleLanguageChange(languageOption.id)}
          >
            <Box sx={{ width: 30, height: 20 }}>
              {Flags[languageOption.flag]({ title: "" })}
            </Box>
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};

LanguageButton.propTypes = {
  renderMiniMenu: PropTypes.bool
};

export default LanguageButton;
